/**
 * POS-SUPPLIERS-PURCHASE-INTEGRITY-001 — parser canónico (espejo backend)
 */

function roundMoney(n) {
  const x = Number(n);
  if (!Number.isFinite(x)) return NaN;
  return Math.round(x * 100) / 100;
}

export function parseCompraNumber(raw, opts = {}) {
  const role = opts.role || 'money';
  const maxDecimals = opts.maxDecimals != null ? opts.maxDecimals : role === 'cantidad' ? 3 : 2;

  if (raw === null || raw === undefined || raw === '') {
    return { ok: false, code: 'EMPTY', message: 'Valor vacío' };
  }
  if (typeof raw === 'number') {
    if (!Number.isFinite(raw)) {
      return { ok: false, code: 'NOT_FINITE', message: 'Número no finito' };
    }
    return finalize(raw, role, maxDecimals);
  }

  const s0 = String(raw).trim().replace(/\s/g, '');
  if (!s0 || /[a-zA-Z_xX]/.test(s0)) {
    return { ok: false, code: 'INVALID_CHARS', message: 'Formato numérico inválido' };
  }

  const hasComma = s0.includes(',');
  const hasDot = s0.includes('.');

  if (hasDot && !hasComma) {
    const m = s0.match(/^-?\d+\.(\d+)$/);
    if (m && m[1].length === 3) {
      return {
        ok: false,
        code: 'AMBIGUOUS_THOUSANDS',
        message:
          'Formato ambiguo (¿miles o decimales?). Usá 1100 o 1,100 según corresponda, sin punto de miles.',
      };
    }
  }

  let normalized = s0;
  if (hasComma && hasDot) {
    const lastComma = s0.lastIndexOf(',');
    const lastDot = s0.lastIndexOf('.');
    if (lastComma > lastDot) {
      normalized = s0.replace(/\./g, '').replace(',', '.');
    } else {
      normalized = s0.replace(/,/g, '');
    }
  } else if (hasComma) {
    normalized = s0.replace(/\./g, '').replace(',', '.');
  }

  const n = Number(normalized);
  if (!Number.isFinite(n)) {
    return { ok: false, code: 'NAN', message: 'No se pudo interpretar el número' };
  }
  return finalize(n, role, maxDecimals);
}

function finalize(n, role, maxDecimals) {
  const factor = 10 ** maxDecimals;
  const rounded = Math.round(n * factor) / factor;
  if (Math.abs(n - rounded) > 1 / (factor * 10)) {
    return {
      ok: false,
      code: 'TOO_MANY_DECIMALS',
      message: `Máximo ${maxDecimals} decimales`,
    };
  }
  if (role === 'cantidad' && !(rounded > 0)) {
    return { ok: false, code: 'QTY_NOT_POSITIVE', message: 'La cantidad debe ser mayor que cero.' };
  }
  if ((role === 'precio' || role === 'money') && !(rounded >= 0)) {
    return { ok: false, code: 'PRICE_NEGATIVE', message: 'El precio no puede ser negativo.' };
  }
  return { ok: true, value: role === 'cantidad' ? rounded : roundMoney(rounded) };
}

export function buildCompraResumen(detalles) {
  const lines = [];
  let total = 0;
  let unidades = 0;
  for (let i = 0; i < (detalles || []).length; i++) {
    const d = detalles[i];
    if (!d?.producto_id) continue;
    const q = parseCompraNumber(d.cantidad, { role: 'cantidad' });
    const p = parseCompraNumber(d.precio_unitario, { role: 'precio' });
    if (!q.ok || !p.ok || !(p.value > 0)) {
      return { ok: false, lineIndex: i, qty: q, price: p };
    }
    const subtotal = roundMoney(q.value * p.value);
    total = roundMoney(total + subtotal);
    unidades += q.value;
    lines.push({
      index: i,
      producto_id: d.producto_id,
      nombre: d.producto_info?.nombre || d.producto_id,
      cantidad: q.value,
      precio_unitario: p.value,
      subtotal,
    });
  }
  if (!lines.length) return { ok: false, empty: true };
  return { ok: true, lines, total, unidades, productos: lines.length };
}

export { roundMoney };
